import { format as dateFnsFormat } from 'date-fns';

import { dateFnsLocales, locales } from './constants';
import { type Format, type FormatString } from './types';

/**
 * Localized **date-fns** `format` function
 *
 * *https://date-fns.org/v2.21.2/docs/format#description*
 *
 * @param {number | Date} date
 * @param {string} formatStr
 * @param {string} locale
 * @returns {string} formatted date
 */
const formatDate = (
  date: number | Date,
  formatStr: Format | FormatString,
  locale: string = locales.getLanguage(),
): string => {
  return dateFnsFormat(date, locales[formatStr as Format] || formatStr, {
    locale: dateFnsLocales[locale],
  });
};

export default formatDate;
